(function () {
  class GambleIntro extends PIXI.Container {
    constructor() {
      super();
      this._numFS = undefined;
      this._callbackOnBaseHidden = undefined;
      this._callback = undefined;
      this._screenDim = undefined;
      this._splashContinue = undefined;

      this._totemParent = undefined;
      this._popup = undefined;
      this._introText1 = undefined;
      this._freespinIntroElements = [];
      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._startFreeSpinsButton = undefined;
      this._gambleButton = undefined;

      this.youHaveFreeSpinsText = undefined;
      this._winChance = undefined;

      this._freeSpinsIntroOutro = undefined;

      this._fsText1 = undefined;
      this._fsText2 = undefined;
      this._fsText3 = undefined;

      this._possibleValues = undefined;

      this._winIntroAnim = undefined;
      this._winAnimIntroPositions = [];

      this._currentFSIndex = 0;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.youHaveFreeSpinsText = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsYouHaveText"
      );

      this._startFreeSpinsButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsButton"
      );
      this._gambleButton = resourceManager.get(
        "gambleIntroContainer:GambleIntro:gambleButton"
      );

      this._gambleDisclaimer = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer"
      );
      this._gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");

      this._startFreeSpinsButton.mousedown =
        this._startFreeSpinsButton.touchstart = this.onClickedStart.bind(this);
      this._gambleButton.mousedown = this._gambleButton.touchstart =
        this.onClickedGamble.bind(this);

      this._freeSpinsIntroOutro = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
      );

      this._fsText1 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsContainer:freeSpinsNumber1"
      );
      this._fsText2 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsContainer:freeSpinsNumber2"
      );
      this._fsText3 = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsContainer:freeSpinsNumber3"
      );

      this._winIntroAnim = resourceManager.get(
        "gambleIntroContainer:GambleIntro:freeSpinsContainer:burstAnim"
      );

      this.setWinAnimIntroPositions();

      messageBus.subscribe("Gamble:Risk", this.onCommittedToGamble.bind(this));
      messageBus.subscribe("Gamble:Collect", this.onClickedStart.bind(this));
      messageBus.subscribe(
        "Gamble:OfferGamble",
        this.onGambleOffered.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.setWinAnimIntroPositions.bind(this)
      );
    }

    setWinAnimIntroPositions() {
      this._winAnimIntroPositions = [];
      this._winAnimIntroPositions.push(this._fsText1.position.get());
      this._winAnimIntroPositions.push(this._fsText2.position.get());
      this._winAnimIntroPositions.push(this._fsText3.position.get());

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[this._currentFSIndex].x,
        this._winAnimIntroPositions[this._currentFSIndex].y
      );
    }

    onClickedStart() {
      this._startFreeSpinsButton.interactive = false;
      this._gambleButton.interactive = false;
      this._callback("collect");
      this.visible = false;
      soundManager.play("buttonPressed");
    }

    doFS() {
      resourceManager.getContainer("fsBackgroundContainer").visible = true;

      resourceManager.getContainer("freeSpinsContainer").visible = true;

      this.alpha = 1;
      this.visible = false;

      this._callback();
    }

    onCommittedToGamble() {
      this._callback("gambled");
    }

    reactivate(numFS, winChance, callback) {
      this._winChance = winChance;
      this._callback = callback;

      this._gambleSpin.start(this._winChance, this._possibleValues, false);
    }

    onGambleOffered() {
      let showDisclaimerButton = resourceManager.get(
        "gambleDisclaimerContainer:GambleDisclaimer:showAgainToggle"
      );
      let show = showDisclaimerButton.getShowDisclaimer();

      const self = this;
      if (show && !gameController.inRecovery) {
        this._gambleDisclaimer.start(this._winChance, this._possibleValues);
      } else {
        this._gambleSpin.start(this._winChance, this._possibleValues, true);
      }
    }

    onClickedGamble() {
      messageBus.post("Gamble:OfferGamble");

      soundManager.play("buttonPressed");
    }

    doShowIntro(numFS, callback) {
      this._numFS = numFS;
      this._callback = callback;
      this._freeSpinsIntroOutro.showIntro(this._numFS, this.doFS.bind(this));
    }

    start(numFS, winChance, possibleValues, fsIndex, hiddenCallback, callback) {
      this._numFS = numFS;
      this._winChance = winChance;

      this._callbackOnBaseHidden = hiddenCallback;
      this._callback = callback;

      this.visible = true;
      this._possibleValues = possibleValues;

      this._fsText1.text = this._possibleValues[0];
      this._fsText2.text = this._possibleValues[1];
      this._fsText3.text = this._possibleValues[2];

      resourceManager.getContainer("gambleIntroContainer").visible = true;
      this._startFreeSpinsButton.interactive = true;
      this._gambleButton.interactive = true;

      this.youHaveFreeSpinsText.setTranslationParameters(numFS);

      this._winIntroAnim.position.set(
        this._winAnimIntroPositions[fsIndex].x,
        this._winAnimIntroPositions[fsIndex].y
      );

      this._currentFSIndex = fsIndex;

      messageBus.post("Gamble:IntroVisible");
      this._callbackOnBaseHidden();
    }
  }

  let gambleIntroCreator = function (json) {
    return new GambleIntro();
  };

  let gambleIntroInitialiser = function (json, fsIntro) {
    fsIntro.initialise();
  };

  let gambleIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleIntro",
    gambleIntroCreator,
    gambleIntroInitialiser,
    gambleIntroFilesRequired
  );
})();
